import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef, type ReactNode } from 'react';
import { muiColorKeys, type TablerCompatIconProps } from './iconCompat';

export function createLocalIcon(displayName: string, children: ReactNode) {
    const Component = forwardRef<SVGSVGElement, TablerCompatIconProps>(function LocalIcon(
        { size, stroke, strokeWidth, color, sx, ...props },
        ref
    ) {
        const cssColor = color && !muiColorKeys.has(color) ? color : undefined;

        return (
            <SvgIcon
                ref={ref}
                viewBox="0 0 24 24"
                htmlColor={cssColor}
                color={cssColor ? undefined : (color as SvgIconProps['color'])}
                sx={{
                    fill: 'none',
                    stroke: 'currentColor',
                    strokeWidth: stroke ?? strokeWidth ?? 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    ...(size !== undefined ? { fontSize: size } : {}),
                    ...(typeof sx === 'object' && sx !== null ? sx : {})
                }}
                {...props}
            >
                {children}
            </SvgIcon>
        );
    });

    Component.displayName = displayName;

    return Component;
}
